/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Password Icon component.
 */
export const PasswordIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 16 23" fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.75' y='8.75' width='14.5' height='13.5' rx='1.25' stroke={iconColor} strokeWidth='1.5'/>
      <circle cx='8.5' cy='15.5' r='1.5' fill={iconColor}/>
      <path d='M3.13197 8.5C2.68426 6.16859 3.09913 0.645327 8.82991 1.01797C14.5607 1.39061 13.4294 8.5 13.4294 8.5'
        stroke={iconColor} strokeWidth='1.5'/>
    </svg>
  );
};
